/**
 * @generated SignedSource<<801f2c3b01e71bd6d0cde943fc22c768>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CommunityGuestSelectAllCheckboxQuery$variables = {
  hasBeenInvited?: boolean | null;
  id: string;
  search?: string | null;
};
export type CommunityGuestSelectAllCheckboxQuery$data = {
  readonly organization: {
    readonly guestMemberships?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly email: string | null;
          readonly id: string;
          readonly user: {
            readonly id: string;
          };
        };
      }>;
    };
  } | null;
};
export type CommunityGuestSelectAllCheckboxQuery = {
  response: CommunityGuestSelectAllCheckboxQuery$data;
  variables: CommunityGuestSelectAllCheckboxQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "hasBeenInvited"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "hasBeenInvited",
          "variableName": "hasBeenInvited"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        }
      ],
      "concreteType": "GuestMembershipNodeConnection",
      "kind": "LinkedField",
      "name": "guestMemberships",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "GuestMembershipNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "GuestMembership",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v4/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "email",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "user",
                  "plural": false,
                  "selections": [
                    (v4/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Organization",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CommunityGuestSelectAllCheckboxQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CommunityGuestSelectAllCheckboxQuery",
    "selections": [
      {
        "alias": "organization",
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v5/*: any*/),
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "adff252d289c36abd806d4f5a0709cec",
    "id": null,
    "metadata": {},
    "name": "CommunityGuestSelectAllCheckboxQuery",
    "operationKind": "query",
    "text": "query CommunityGuestSelectAllCheckboxQuery(\n  $id: ID!\n  $search: String\n  $hasBeenInvited: Boolean\n) {\n  organization: node(id: $id) {\n    __typename\n    ... on Organization {\n      guestMemberships(search: $search, hasBeenInvited: $hasBeenInvited) {\n        edges {\n          node {\n            id\n            email\n            user {\n              id\n            }\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "8a6794d3cdf52c4998701176afa3b768";

export default node;
